/** Normalize URL typos like http://192.168.1.20.:5553 */
export const sanitizeBaseUrl = (url) => {
  if (!url) return "";
  return url.trim().replace(/\/$/, "").replace(/\.+:/g, ":");
};

/** Base URL from REACT_APP_BACKEND_LINK (e.g. http://host:5553) */
export const getApiBaseUrl = () => {
  const link = process.env.REACT_APP_BACKEND_LINK;
  if (!link) return sanitizeBaseUrl(process.env.REACT_APP_SOCKET_URL);
  return sanitizeBaseUrl(link.replace("/api/gtbs", ""));
};

/** Socket + progress: use SOCKET_URL only when it matches API host; else API base */
export const getServerBaseUrl = () => {
  const apiBase = getApiBaseUrl();
  const socketEnv = sanitizeBaseUrl(process.env.REACT_APP_SOCKET_URL);

  if (!socketEnv) return apiBase;
  if (!apiBase) return socketEnv;

  try {
    const sameHost = new URL(socketEnv).origin === new URL(apiBase).origin;
    return sameHost ? socketEnv : apiBase;
  } catch {
    return apiBase || socketEnv;
  }
};
